// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    background-color: #fff;
    color: #ffcc29;
    padding: 5px;
    position: fixed;
    top: 0;
    /* left: -260px; Initially hidden */
    left: -280px; /* Initially hidden */
    height: 100vh;
    overflow-y: auto;
    transition: left 0.3s ease;
    z-index: 1000;
  }
  
  .sidebar.open {
    left: 0; /* Slide in when open */
  }

/* Sidebar Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 5px; 
}

.sidebar::-webkit-scrollbar-thumb {
  background-color: #c1c1c1; 
  border-radius: 10px;
}

.sidebar::-webkit-scrollbar-track {
  background: #fff; 
}

.sidebar-menu a.active {
  font-weight: bold;
  background-color: #ffcc29;
  color: #000;
}

  
  .sidebar-title {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 2rem;
    font-weight: bold;
    visibility: hidden;
  }
  
  .sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-menu li {
    margin: 1.5rem 0;
  }
  
  .sidebar-menu a {
    text-decoration: none;
    color: #373435;
    font-size: 1rem;
    display: flex;
    align-items: center; 
    gap: 0.8rem; 
    padding: 0.5rem 0.8rem; 
    border-radius: 8px; 
    transition: background-color 0.3s ease;
    cursor: pointer;
  }
  
  .sidebar-menu a:hover {
    color: #000; 
    background-color: #ffcc29; /* Add hover background */
  }
  
  .sidebar-icon {
    font-size: 1.2rem; /* Adjust icon size */
  }
  
  .menu-toggle {
    background: none;
    border: none;
    color: #373435;
    font-size: 1rem;
    cursor: pointer;
    text-align: left;
    width: 100%;
    padding: 0.5rem 0.8rem;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
  
  .menu-toggle:hover {
    background-color: #ffcc29;
    color: #000;
  }

  .submenu-wrapper {
    max-height: 0;
    overflow: hidden;
    transition: max-height 2s ease;
  }
  
  .submenu-wrapper.open {
    max-height: 500px; /* Or a value that fits all items */
  }
  
  
  .submenu {
    list-style: none;
    padding: 0;
    display: none; 
  }

  
  .submenu.visible {
    display: block; /* Show when toggled */
  }

  .submenu a.active {
    font-weight: bold;
    background-color: #ffcc29;
    color: #000;
  }
  
  
  .submenu li {
    margin: 0.5rem 0;
  }
  
  .submenu li a {
    font-size: 0.9rem;
  }

  .submenu li a:hover {
    font-weight: 600;
  }

  
  .submenu.visible + .menu-toggle .arrow-icon {
    transform: rotate(180deg); /* Rotate when submenu is open */
  }

  .sidebar-search-filter {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .sidebar-search-filter input { 
    padding: 8px !important;
  }
  
  .mic-icon {
    cursor: pointer;
    color: #444;
    font-size: 20px;
  }
  
  .mic-icon.listening {
    animation: pulse 1s infinite;
    color: red;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.9;
    }
    50% {
      transform: scale(1.3);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 0.9;
    }
  }
  

  @media screen and (max-width: 550px) {
    .sidebar {
      width: 200px;
    }

    .menu-toggle {
        font-size: 12px;
    }

    .sidebar-menu a {
        font-size: 12px;
    }
  }


  .arrow-icon {
    margin-left: auto;
    transition: transform 0.3s ease;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,MAAM;IACN,mCAAmC;IACnC,YAAY,EAAE,qBAAqB;IACnC,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,OAAO,EAAE,uBAAuB;EAClC;;AAEF,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;;EAGE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB,EAAE,yBAAyB;EACtD;;EAEA;IACE,iBAAiB,EAAE,qBAAqB;EAC1C;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB,EAAE,mCAAmC;EACxD;;;EAGA;IACE,gBAAgB;IAChB,UAAU;IACV,aAAa;EACf;;;EAGA;IACE,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;EACb;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,YAAY;IACd;EACF;;;EAGA;IACE;MACE,YAAY;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;EACF;;;EAGA;IACE,iBAAiB;IACjB,+BAA+B;EACjC","sourcesContent":[".sidebar {\r\n    background-color: #fff;\r\n    color: #ffcc29;\r\n    padding: 5px;\r\n    position: fixed;\r\n    top: 0;\r\n    /* left: -260px; Initially hidden */\r\n    left: -280px; /* Initially hidden */\r\n    height: 100vh;\r\n    overflow-y: auto;\r\n    transition: left 0.3s ease;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .sidebar.open {\r\n    left: 0; /* Slide in when open */\r\n  }\r\n\r\n/* Sidebar Scrollbar Styling */\r\n.sidebar::-webkit-scrollbar {\r\n  width: 5px; \r\n}\r\n\r\n.sidebar::-webkit-scrollbar-thumb {\r\n  background-color: #c1c1c1; \r\n  border-radius: 10px;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-track {\r\n  background: #fff; \r\n}\r\n\r\n.sidebar-menu a.active {\r\n  font-weight: bold;\r\n  background-color: #ffcc29;\r\n  color: #000;\r\n}\r\n\r\n  \r\n  .sidebar-title {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n    font-weight: bold;\r\n    visibility: hidden;\r\n  }\r\n  \r\n  .sidebar-menu {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n  \r\n  .sidebar-menu li {\r\n    margin: 1.5rem 0;\r\n  }\r\n  \r\n  .sidebar-menu a {\r\n    text-decoration: none;\r\n    color: #373435;\r\n    font-size: 1rem;\r\n    display: flex;\r\n    align-items: center; \r\n    gap: 0.8rem; \r\n    padding: 0.5rem 0.8rem; \r\n    border-radius: 8px; \r\n    transition: background-color 0.3s ease;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .sidebar-menu a:hover {\r\n    color: #000; \r\n    background-color: #ffcc29; /* Add hover background */\r\n  }\r\n  \r\n  .sidebar-icon {\r\n    font-size: 1.2rem; /* Adjust icon size */\r\n  }\r\n  \r\n  .menu-toggle {\r\n    background: none;\r\n    border: none;\r\n    color: #373435;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    width: 100%;\r\n    padding: 0.5rem 0.8rem;\r\n    border-radius: 8px;\r\n    transition: background-color 0.3s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.8rem;\r\n  }\r\n  \r\n  .menu-toggle:hover {\r\n    background-color: #ffcc29;\r\n    color: #000;\r\n  }\r\n\r\n  .submenu-wrapper {\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: max-height 2s ease;\r\n  }\r\n  \r\n  .submenu-wrapper.open {\r\n    max-height: 500px; /* Or a value that fits all items */\r\n  }\r\n  \r\n  \r\n  .submenu {\r\n    list-style: none;\r\n    padding: 0;\r\n    display: none; \r\n  }\r\n\r\n  \r\n  .submenu.visible {\r\n    display: block; /* Show when toggled */\r\n  }\r\n\r\n  .submenu a.active {\r\n    font-weight: bold;\r\n    background-color: #ffcc29;\r\n    color: #000;\r\n  }\r\n  \r\n  \r\n  .submenu li {\r\n    margin: 0.5rem 0;\r\n  }\r\n  \r\n  .submenu li a {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .submenu li a:hover {\r\n    font-weight: 600;\r\n  }\r\n\r\n  \r\n  .submenu.visible + .menu-toggle .arrow-icon {\r\n    transform: rotate(180deg); /* Rotate when submenu is open */\r\n  }\r\n\r\n  .sidebar-search-filter {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n\r\n  .sidebar-search-filter input { \r\n    padding: 8px !important;\r\n  }\r\n  \r\n  .mic-icon {\r\n    cursor: pointer;\r\n    color: #444;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .mic-icon.listening {\r\n    animation: pulse 1s infinite;\r\n    color: red;\r\n  }\r\n  \r\n  @keyframes pulse {\r\n    0% {\r\n      transform: scale(1);\r\n      opacity: 0.9;\r\n    }\r\n    50% {\r\n      transform: scale(1.3);\r\n      opacity: 0.5;\r\n    }\r\n    100% {\r\n      transform: scale(1);\r\n      opacity: 0.9;\r\n    }\r\n  }\r\n  \r\n\r\n  @media screen and (max-width: 550px) {\r\n    .sidebar {\r\n      width: 200px;\r\n    }\r\n\r\n    .menu-toggle {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .sidebar-menu a {\r\n        font-size: 12px;\r\n    }\r\n  }\r\n\r\n\r\n  .arrow-icon {\r\n    margin-left: auto;\r\n    transition: transform 0.3s ease;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
